export function isQueryTraceSupported() {
  const mobile = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  return !mobile && window.matchMedia('(min-width: 1280px)').matches;
}
export function subscribeQueryTraceSupport(listener: () => void) {
  const media = window.matchMedia('(min-width: 1280px)');
  media.addEventListener('change', listener);
  return () => media.removeEventListener('change', listener);
}

let recording = false;
let action: { id: string; label: string; at: number } | null = null;
const recordingListeners = new Set<() => void>();
export function getQueryTraceRecording() { return recording; }
export function subscribeQueryTraceRecording(listener: () => void) {
  recordingListeners.add(listener);
  return () => { recordingListeners.delete(listener); };
}
export function setQueryTraceRecording(enabled: boolean) {
  enabled = enabled && isQueryTraceSupported();
  if (recording === enabled) return;
  recording = enabled;
  recordingListeners.forEach(listener => listener());
}
export function captureQueryTraceAction(target: EventTarget | null) {
  if (!isQueryTraceSupported() || !recording || !(target instanceof Element)) return;
  if (target.closest('[data-query-trace-panel]')) return;
  const control = target.closest('button, a, [role="tab"], [role="button"]');
  if (!control) return;
  const label = control.getAttribute('aria-label') || control.getAttribute('title') || control.textContent || 'Tıklama';
  action = { id: `${Date.now()}-${Math.random().toString(36).slice(2)}`, label: label.trim().replace(/\s+/g, ' ').slice(0, 120), at: Date.now() };
}
export function queryTraceHeaders() {
  if (!isQueryTraceSupported() || !recording) return {};
  const recent = action && Date.now() - action.at < 10000 ? action : null;
  // Encode labels because HTTP headers cannot carry arbitrary Turkish Unicode text.
  return {
    'x-query-action-id': recent?.id ?? '',
    'x-query-action': encodeURIComponent(recent?.label ?? 'Arka plan / sayfa isteği'),
    'x-query-page': window.location.pathname,
  };
}
